import { cn } from "@/lib/utils";
import { CREATOR_FLOATING_ACTIONS_CLASS_NAME } from "./creatorDetail.constants";
import type { CreatorFloatingActionsProps } from "./creatorDetail.types";

export function CreatorFloatingActions({
  children,
  className,
  ...props
}: CreatorFloatingActionsProps) {
  return (
    <div className={cn(CREATOR_FLOATING_ACTIONS_CLASS_NAME, className)} {...props}>
      <div className="pointer-events-auto flex w-full items-center gap-2">
        {children}
      </div>
    </div>
  );
}
